export default function ({ $auth, redirect }) {
    if ($auth.user.role.name !== 'Super-Admin') {
        return redirect('/');
    }
}
